
declare const KTThemeMode: any;
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
 // <-- Only if Metronic provides global object

export class ThemeService {
  initThemeListener(): void {
    const toggleInput = document.querySelector<HTMLInputElement>('[data-theme-toggle="true"]');
    if (!toggleInput) return;

    const applyTheme = (mode: 'light' | 'dark') => {
      document.documentElement.classList.remove('light', 'dark');
      document.documentElement.classList.add(mode);
      localStorage.setItem('theme', mode);
    };

    // Load theme from localStorage or system
    let savedTheme = localStorage.getItem('theme') || 'system';
    if (savedTheme === 'system') {
      savedTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }

    // Apply the initial theme
    applyTheme(savedTheme as 'light' | 'dark');
    toggleInput.checked = savedTheme === 'dark';

    // Listen to checkbox toggle
    toggleInput.addEventListener('change', () => {
      const isDark = toggleInput.checked;
      applyTheme(isDark ? 'dark' : 'light');
    });
  }
}
